import React from "react";

type SummaryPageViewProps = {
    className?: string;
    label: string;
    value?: string;
};

export default function SummaryPageView({ className, label, value }: SummaryPageViewProps) {
    return (
        <div
            className={`flex flex-col gap-0.5 border-b border-gray-100 py-3 last:border-b-0 md:flex-row md:items-baseline md:gap-4 ${className ?? ''}`}
        >
            <p className="text-base text-gray-500 md:w-1/2 md:flex-shrink-0">{label}</p>
            <p className="text-base font-medium text-gray-900 whitespace-pre-line break-words md:w-1/2">
                {value ? value : "—"}
            </p>
        </div>
    );
}
